export default function PiWidget(props: {
  children?: JSX.Element | JSX.Element[] | string;
}) {
  return (
    <div className="absolute bg-creator-primary-background flex gap-[6px] px-[8px] z-10 h-[40px] bottom-[16px] left-[16px] rounded-[5px] justify-center items-center">
      {props.children}
    </div>
  );
}
